commusoftCommon.filter('supplierContactDateFormat', function() {
    return function(dateString) {
        return moment(dateString).format('YYYY-MM-DD')
    };
});